<template>
  <div class="notifications">
    <b-notification type="is-danger" v-if="errors">
      <ul>
        <li v-for="(error, index) in errors.flatten()" :key="index">
          {{ error }}
        </li>
      </ul>
    </b-notification>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: mapState(["errors"])
};
</script>
